import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const RadialBarChart = ({ radialChartDataSet }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (
      radialChartDataSet &&
      Array.isArray(radialChartDataSet.series) &&
      Array.isArray(radialChartDataSet.labelName) &&
      Array.isArray(radialChartDataSet.colors)
    ) {
      setChartOptions({
        options: {
          chart: {
            type: "radialBar",
            toolbar: {
              show: true, // Enables the toolbar
              tools: {
                download: false, // Enables the download button
              },
            },
          },
          plotOptions: {
            radialBar: {
              track: {
                strokeWidth: "80%", // Width of the track background
              },
              hollow: {
                size: "30%", // Controls the size of the inner circle
              },
              dataLabels: {
                name: {
                  fontSize: "22px",
                },
                value: {
                  fontSize: "16px",
                },
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => {
                    return `${radialChartDataSet.sumAlltransaction}`;
                  }, // Custom total formatter
                },
              },
            },
          },
          stroke: {
            lineCap: "round", // Options: 'round', 'butt', 'square'
            width: 5, // Width of the stroke
          },
          labels: radialChartDataSet?.labelName || [], // Labels for each segment
          colors: radialChartDataSet?.colors || [], // Custom colors
        },
        series: radialChartDataSet?.series || [], // Values for each segment
      });
    } else {
      console.error("Invalid radialChartDataSet structure", radialChartDataSet);
    }
  }, [radialChartDataSet]);

  return (
    <div>
      {chartOptions ? (
        <Chart
          options={chartOptions?.options}
          series={chartOptions?.series}
          type="radialBar"
          height={300}
        />
      ) : (
        <p>Loading chart...</p>
      )}
    </div>
  );
};

export default RadialBarChart;
